import { Typography } from "@mui/material";
import { getYear } from "date-fns";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const AllRightsReserved = () => {
  const { t } = useTranslation();
  const currentYear = useMemo(() => {
    return getYear(new Date());
  }, []);

  return (
    <Typography sx={{ color: "#6C7278", mt: 5 }}>
      © {currentYear} HolaVida.{" "}
      <Typography component={"span"}>{t(`signup.rights`)}</Typography>
    </Typography>
  );
};

export default AllRightsReserved;
